import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import "@/styles/globals.css";
import { ClerkProvider } from "@clerk/clerk-react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import "./instrumentation.ts";

import { ApiAuthSync } from "./components/auth/api-auth-sync";

import { CONSTANTS } from "./config/constants.tsx";
import { initializeMockData } from "./mock";
import { router } from "./router.tsx";

// Initialize mock data if enabled
initializeMockData();

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
  },
});

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found");
}

// Reuse root during HMR
const root = (globalThis as any).__app_root ?? ReactDOM.createRoot(rootElement);

if (!(globalThis as any).__app_root) {
  (globalThis as any).__app_root = root;
}

root.render(
  <ClerkProvider
    publishableKey={CONSTANTS.CLERK_PUBLISHABLE_KEY}
    afterSignOutUrl="/auth/sign-in"
  >
    <ApiAuthSync />
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
    </QueryClientProvider>
  </ClerkProvider>,
);
